import type { TFunction } from 'i18next'

import { formatDate } from '../../lib/format'
import type { TruckAvailability } from '../availability/api'
import type { Load } from '../loads/api'

/** "Kissimmee, FL → Marana, AZ" — the book's own words for a load's route. */
export function routeLine(load: Load, t: TFunction): string {
  const origin = load.stops[0]
  const destination = load.stops[load.stops.length - 1]

  return t('loads.book.routeLine', {
    origin: origin === undefined ? '' : `${origin.city}, ${origin.state}`,
    destination: destination === undefined ? '' : `${destination.city}, ${destination.state}`,
  })
}

/** The first pickup's days, the way the book prints them. */
export function pickupDays(load: Load, t: TFunction, language: string): string {
  const origin = load.stops[0]

  if (origin?.windowFrom == null) {
    return ''
  }

  return origin.windowTo === null || origin.windowTo === origin.windowFrom
    ? formatDate(origin.windowFrom, language)
    : t('loads.book.window', {
        from: formatDate(origin.windowFrom, language),
        to: formatDate(origin.windowTo, language),
      })
}

/** A posting's days on offer, the way the board prints them. */
export function availableDays(posting: TruckAvailability, t: TFunction, language: string): string {
  return t('loads.book.window', {
    from: formatDate(posting.availableFrom, language),
    to: formatDate(posting.availableUntil, language),
  })
}
